<template>
    <tr class="clickable-row">
        <td><a href="" @click.prevent.stop >{{reservation.fingerprint}}</a></td>
        <td><a href="" @click.prevent.stop>{{getDataExtendString(reservation.created_date)}}</a></td>
        <td v-if="showUser"><a href="" @click.prevent.stop>{{reservation.client.first_name + " " + reservation.client.last_name}}</a></td>
        <td><a href="" @click.prevent.stop>{{reservation.rate_name}}</a></td>
        <td><a href="" @click.prevent.stop><span class="label label-default">{{getStringChannelMode(reservation.channel)}}</span></a></td>
        <td><a href="" @click.prevent.stop><span :class="getClassLabelReservationState(reservation.state)" class="label">{{getStringReservationState(reservation.state)}}</span></a></td>
        <td><a href="" @click.prevent.stop>{{reservation.admin_creator_name}}</a></td>
        <td v-if="reservation.paid_by_subscription"><a href="" @click.prevent.stop>Abbonamento #{{reservation.paid_by_subscription.fingerprint}}</a></td>
        <td v-else><a href="" @click.prevent.stop>{{getStringPaymentMode(reservation.payment_mode)}}</a></td>
    </tr>
</template>

<script>
    import {Utils} from "../../common/utils";

    export default {
        name: "ReservationRow",
        props: {
            reservation: {
                type: Object,
                require: true
            },
            showUser: {
                type: Boolean,
                default: true
            }
        },
        methods: {
            getClassLabelReservationState(state) {
                return Utils.getClassLabelReservationState(state)
            },
            getStringReservationState(state) {
                return Utils.getStringReservationState(state)
            },
            getStringPaymentMode(payment_mode) {
                return Utils.getStringPaymentMode(payment_mode)
            },
            getStringChannelMode(channel) {
                return Utils.getStringChannelMode(channel)
            },
            getDataString(date) {
                return Utils.getShortDateStringFromISO(date)
            },
            getDataExtendString(date){
                return Utils.getDateStringFromISO(date)
            },
        }
    };
</script>
